module.exports = __webpack_public_path__ + "Roboto-Light.8e0860f3581b197e9fa4.woff2";


//////////////////
// WEBPACK FOOTER
// c:/Wave/Projects/WCI/FastTrack/FastTrack/node_modules/roboto-fontface/fonts/roboto/Roboto-Light.woff2
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-Light.woff2
// module chunks = styles